import React from 'react';

import { ResetPasswordWithToken } from 'src/components/user-flow/reset-password-with-token';

export default function ResetPasswordRoute() {
  return <ResetPasswordWithToken />;
}
